// extracted by mini-css-extract-plugin
export default {"text":"deleteBrandModals_text__8FWZX","container":"deleteBrandModals_container__+LMYH"};